import { pathJoin } from 'src/reducers/routing/utils'

export const createKmdEasyFilesDetailViewRoutesMap = (prefix: string) => ({
  view: pathJoin(prefix)('view').chain,
})
